export default __webpack_public_path__ + "static/media/long_term_disability.ad4f71ae.svg";